<template>
  <van-row class="page-show">
    <!-- 背景图片 -->
    <img class="background-show" src="@/assets/background.png" alt="">
    <!-- 表单内容 -->
    <van-col span="24">
      <van-image class="page-show" width="60vw" height="68vh" :src="require('@/assets/index@2x.png')" />
      <!-- <img class="page-show" src="@/assets/index@2x.png" alt=""> -->
      <!-- 下载按钮 -->
      <div class="download-body">
        <div class="download-btn" @click="getLatestVersion(10)">
          <img src="@/assets/Android@2x.png" alt="">
          <p>安卓下载</p>
        </div>
        <div class="download-btn" @click="getLatestVersion(20)">
          <img src="@/assets/Ios@2x.png" alt="">
          <p>苹果下载</p>
        </div>
      </div>
    </van-col>

    <!-- 遮罩按钮 -->
    <van-overlay :show="show" @click="show">
      <img class="download-icon" src="@/assets/download.png" alt="">
      <p class="download-text">请在默认浏览器中打开下载！</p>
    </van-overlay>

    <!-- 返回 -->
    <RouterVIew :page="page" />
  </van-row>
</template>

<script>
  import { getLatestVersion } from '@/api/index'
  import { Toast, Dialog } from 'vant';
  export default {
    name: 'Home',
	  data() {
	    return {
        appFlag: this.isSystem() == 'ios' ? 20 : 10,
        show: false,
        page: '/'
	    };
	  },
    created(){
      // if(this.weixin() == true){
      //   this.show = false;
      // }
    },
	  methods: {
      // 判断
      weixin(){
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          return true
        } else {
          return false
        }
      },
      // 下载内容
      getLatestVersion(data){
				var text = this.appFlag == '20' ? 'ios' : 'Android';
        if(data != this.appFlag){
          Dialog.alert({
            message: '您当前的机型为'+ text +',请下载对应版本！',
          }).then(() => {});
          return
        }
        getLatestVersion({ clientType: data }).then(res => {
          Dialog.confirm({
              title: '提示',
              message: '确定要下载'+ text +'版本APP吗？',
            })
            .then(() => {
              window.location.href = res.data.releaseUrl;
              this.show = true;
            })
            .catch(() => {});
        })
      }
    },
	};
</script>

<style scoped lang="scss">
  .page-show{
    height: 100vh;

    .download-icon{
      position: absolute;
      right: 2vw;
      top: 2vh;
      width: 10vw;
    }

    .download-text{
      font-size: 16px;
      color: white;
      position: absolute;
      right: 2vw;
      top: 6vh;
    }

    .background-show{
      width: 100%;
      height: 99%;
    }

    .page-show{
      // width: 46vw;
      // height: 50vh;
      position: absolute;
      top: 7vh;
      left: 20vw;
    }

    .download-body{
      position: absolute;
      top: 80vh;
      left: 15vw;
      width: 70vw;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .download-btn{
        display: flex;
        align-items: center;
        flex-direction: row;
        border: 1px solid #FFFFFF;
        border-radius: 30px;
        padding: 1vh 3vw;

        img{
          width: 7vw;
          margin-right: 1vw;
        }
        p{
          margin: 0;
          color: #FFFFFF;
          opacity: 1;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
</style>